import Vue from 'vue';
import VueI18n from 'vue-i18n';
import validationMessages from 'vee-validate/dist/locale/ja.json';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: 'ja',
  fallbackLocale: 'ja',
  messages: {
    ja: {
      errHandler: {
        message: {
          httpError:
            '{status}: {message}\nconfig: {config}\nerrInfo: {info}\n{stack}',
          networkError: '{message}\nconfig: {config}\nerrInfo: {info}\n{stack}',
          otherError: '{message}\nerrInfo: {info}\n{stack}',
          postError:
            'エラー通知APIの呼び出しに失敗しました。\nconfig: {config}\n{stack}',
          disp: {
            http400: '{status}: 不正なリクエストです',
            http401: '{status}: 認証エラー',
            http403: '{status}: アクセス権がありません',
            http404: '{status}: 対象が見つかりません',
            http409: '{status}: 操作が競合しました',
            http415: '{status}: メディアタイプがサポートされていません',
            http500: '{status}: エラーが発生しました',
            http502: '{status}: リクエストが拒否されました',
            http503: '{status}: サービスは一時的に利用できません',
            http504: '{status}: ゲートウェイタイムアウトが発生しました',
            httpOther: '{status}: エラーが発生しました',
            network: 'ネットワークエラー'
          }
        }
      },
      message: {
        requiredCreated: 'アカウント登録前のため遷移できません。',
        requiredApproval: '審査承認前のため遷移できません。',
        requiredZuoraInfo: 'アカウント情報の取得に失敗したため遷移できません。',
        failedLogin: 'アカウントのログインに失敗しました。'
      },
      validations: {
        ...validationMessages,
        custom: {
          fullWidthHira: '{_field_}はひらがなのみ使用できます',
          fullWidthKana: '{_field_}は全角カナのみ使用できます',
          isNotScriptTag: '{_field_}はJavaScirptを使用できません',
          isValidPhone: '{_field_}が不正です'
        }
      },
      form: {
        fields: {
          account: 'アカウント名',
          name: '契約者名',
          firstName: '名',
          lastName: '姓',
          company: '企業・団体名',
          department: '部署',
          zipCode: '郵便番号',
          state: '都道府県',
          city: '市区町村',
          address: '住所',
          phone: '電話番号',
          email: 'メールアドレス',
          emailConfirmation: 'メールアドレス',
          queryType: 'お問い合わせ項目',
          queryBody: 'お問い合わせ内容',
          consent: '情報取得の同意',
          groupInviteEmail: '招待メールアドレス'
        },
        label: {
          required: '必須',
          firstName: '名',
          lastName: '姓'
        },
        hint: {
          zipCode: 'ハイフンなし',
          address: '以降の住所',
          phone: 'ハイフンなし',
          company:
            '※ 個人のお客様のアカウント登録は、ご遠慮いただいております。'
        }
      }
    }
  }
});

export default i18n;
